import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            浏览分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按类型探索你喜欢的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300 mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 text-center">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}